import { useDispatch, useSelector } from "react-redux";
import {
  fetchContent,
  selectAuth,
  selectCache,
  selectID,
  selectUXPlatform,
  selectVersion,
} from "../counter/counterSlice";
import { CacheManager } from "../counter/counterAPI";
import { PatientInfo } from "./patientInfodata";

const topicFile = "patient_information_pdfs.dita";
const guideline = "quicklinks/";
function LoadFile(dartSelectors) {
  dartSelectors.iDB.read(topicFile).then((value) => {
    if (value) {
      const parser = new DOMParser();
      const ditaHTML = parser.parseFromString(value, "text/html").body;
      PatientInfo(ditaHTML, dartSelectors);
    } else {
      dartSelectors.dispatch(fetchContent({ guideline, topicFile, dartSelectors }));
    }
  });
}

const PatientInfoContent = ({ showPdfInstruction = true }) => {
  const dartSelectors = {};

  dartSelectors.auth = useSelector(selectAuth);
  let id = useSelector(selectID);
  dartSelectors.ccmsversion = useSelector(selectVersion);
  dartSelectors.uxPlatform = useSelector(selectUXPlatform);
  dartSelectors.cache = useSelector(selectCache);
  dartSelectors.dispatch = useDispatch();
  dartSelectors.iDB = new CacheManager({
    name: `${dartSelectors.ccmsversion.selected}_${import.meta.env.REACT_APP_CONTENT_VERSION}`,
  });

  if (id.u || id.i) {
    LoadFile(dartSelectors);
  }

  return (
    <div className="container" aria-label="Patient Information">
      <div className="container tg_guideline">
        <div className="row">
          <div id="patientId">
            <div className="col-lg-12">
              {showPdfInstruction && (
                <p className="mTop20px">
                  <strong>
                    You will need Adobe Reader to view the PDF files. You can{" "}
                    <a
                      title="Download Adobe Reader for free"
                      href="http://get.adobe.com/uk/reader/"
                      target="_blank"
                      rel="noreferrer"
                    >
                      download Adobe Reader
                    </a>{" "}
                    free of charge.
                  </strong>
                </p>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PatientInfoContent;
